import { Injectable } from '@angular/core';
import hljs from 'highlight.js';

import MarkdownIt from 'markdown-it';

@Injectable({
  providedIn: 'root',
})
export class MarkdownItService {
  private markdownIt: MarkdownIt;

  constructor() {
    this.markdownIt = MarkdownIt({
      html: true,
      breaks: true,
      linkify: true,
      typographer: true,
      highlight: function (str, lang) {
        if (lang && hljs.getLanguage(lang)) {
          try {
            return hljs.highlight(str, { language: lang }).value;
          } catch (__) {}
        }

        return hljs.highlightAuto(str).value; // use external default escaping
      },
    });

    this.markdownIt.linkify.set({ fuzzyEmail: false });
    // this.markdownIt = this.markdownIt.use(mathjax3);
  }

  public render(markdown: string): string {
    return `${this.markdownIt.render(markdown)}`;
  }
}
